<template>
    <div class="cover">
        <div :class="['preview-loading', isCoverShow ? '' : 'iscoverhide']">
            <img class="cover-one" src="../assets/images/preview.png">
            <div class="ICP">粤ICP备2025383852</div>
        </div>
        <div class="cover-content">

            <div style="padding-bottom: 80px;position: relative;">
                <img src='../assets/images/cover/contect_4_03.jpg' />
                <div style="position: absolute;top: 45%;left: 50%;margin-left: -250px;margin-top: 34px;cursor: pointer;width: 500px;height: 80px;" :class="['passwordInput',password != '' ? 'passwordERROInput' : '']">
                    <el-input size="small" v-model="password" type="password" style="position: absolute;left: 50%;width: 160px;margin-left: -80px;top: 70%;margin-top: -40px;" :placeholder="placeholderText" v-if="LogoModelVisible" ref="myInput"></el-input>
                </div>
            </div>

            <div class="Access-model">
                <div class="Access-list" @click="handleGeneral">
                    <h1>General Access</h1>
                    <h2>普通访问</h2>
                    <img src="../assets/images/cover/contect_5_03.jpg" />
                </div>
                <div class="Access-list" @click="handleLogo">
                    <h1>Invitation Access</h1>
                    <h2>受邀访问</h2>
                    <img src="../assets/images/cover/contect_5_03.jpg" />
                </div>
            </div>
        </div>
        

        <!-- <el-dialog title="" 
        :visible.sync="LogoModelVisible"
        width="500px"
        :lock-scroll="false"
        center
        :top="marginTop+'px'"
        :before-close="handleLogoModeClose"
        >
        <div>
            <el-input placeholder="请输入密码" v-model="password" show-password></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="small" @click="handleWebsite" style="background-color: #000;border-color: #000;">进入官网</el-button>
        </span>
        </el-dialog> -->
    </div>
</template>

<script>
// setVisitInfor
import {setPassWord} from '@/api/axios-api'
export default {
    name: 'Cover',
    components: {
       
    },
    data () {
        return {
            LogoModelVisible: false,
            password: '',
            isCoverShow: true,
            marginTop: 0,
            placeholderText: ''
        }
    },

    mounted () {
        // this.setVisitInforFun()

        setTimeout (() => {
            this.isCoverShow = false
            // document.body.style.overflow = 'auto'
        },5000)

        // const bodyHeight = document.body.clientHeight

        // this.marginTop = (bodyHeight / 2) - 70

        // window.onresize = () => {
        //     const bodyHeight = document.body.clientHeight
        //     this.marginTop = (bodyHeight / 2) - 70
        // }

        window.addEventListener('keyup', this.globalKeyupHandler)
        // console.log(bodyHeight)
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.globalKeyupHandler);
    },
    
    methods: {

        // 访问信息
        // setVisitInforFun () {
        // setVisitInfor().then(res => {
        //     // console.log(res)
        //     if (res.code == 0) {
        //         sessionStorage.setItem('isVisited',res.map.ispc)
        //     }
        // })
        // },

        // 普通访问
        handleGeneral () {

            sessionStorage.setItem('loginMethod',0)
            this.$router.push({
                path: '/',
            })

            sessionStorage.removeItem('projectList')
            sessionStorage.removeItem('isCache')
            sessionStorage.removeItem('videolist')
        },

        globalKeyupHandler(event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                // console.log('全局回车键被按下');
                this.handleWebsite()
                // 添加你的逻辑
            }
        },
        handleWebsite () {
            if (this.password == '') {
                this.$message.error('请输入密码')
                return false
            }
            const parseInfo = {}
            parseInfo.pwd = this.password
            setPassWord(parseInfo).then(res => {
                // console.log(res)
                if (res.code == 0) {
                    sessionStorage.setItem('loginMethod',1)
                    this.$router.push({
                        path: '/',
                    })
                    sessionStorage.removeItem('projectList')
                    sessionStorage.removeItem('isCache')
                    sessionStorage.removeItem('videolist')
                } else {
                    this.password = ''
                    this.placeholderText = '密码错误'

                    setTimeout(() => {
                        this.placeholderText = ''
                    },2000)
                    // this.$message({
                    //     message: res.message,
                    //     type: 'error'
                    // })
                }
            })
        },

        handleLogo () {
            this.LogoModelVisible = true
            this.$nextTick(() => {
                this.$refs.myInput.focus()
            })
        },
        handleLogoModeClose () {
            this.password = ''
            this.LogoModelVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.cover {
    width: 100%;
    height: 100%;
    // height: 114vh;
    // background: #fff;
    // position: fixed;
    // justify-content: center;
    // align-items: center;
    text-align: center;
}

.cover .preview-loading {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 999;
  background: #000;
  opacity: 1; /* 完全不透明 */
  transition: transform 2s ease, opacity 2s ease; /* 添加过渡效果 */
}
.cover .preview-loading img{
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 2s ease, opacity 2s ease; /* 添加过渡效果 */
  // transform: scale(1); /* 初始状态，无缩放 */
  opacity: 1; /* 完全不透明 */
  background: #000;
}
.cover .preview-loading.iscoverhide {
  z-index: 9;
  height: 99vh;
  opacity: 0; /* 同时变为透明 */
  display: none;
}
.cover .cover-content {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    z-index: 15;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // margin-top: -125px;
}
.cover .cover-logo {
    // width: 200px;
    // height: 200px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 40%;
    cursor: pointer;
}
.cover .cover-two {
    width: 100%;
    height: 100vh;
    object-fit: cover;
    // margin-top: 50px;
}
.cover .ICP {
    position: absolute;
    right: 100px;
    bottom: 50px;
    color: rgb(182, 182, 182);
    font-size: 15px;
    font-family: Helvetica;
}
.cover::v-deep .passwordInput .el-input__inner {
    background-color: #000;
    border-radius: 15px;
    border: 1px solid #000;
    color: #fff;
    font-size: 15px;
    font-family: '微软雅黑';
    // font-weight: 700;
    text-align: center;
    letter-spacing: 5px;
    padding: 3px 15px 5px 15px;
}
.cover::v-deep .passwordERROInput .el-input__inner{
    font-size: 25px;
}
.cover .Access-model {
    display: flex;
    justify-content: center;
    margin-left: 18px;
}

.cover .Access-list:nth-child(1) {
    padding-right: 30px;
    position: relative;
    cursor: pointer;
}
.cover .Access-list:nth-child(1)::before {
    content: '';
    display: inline-block; 
    height: 65px;
    width: 4px;
    // border: 2px solid #000;
    background: #000;
    position: absolute;
    right: 0;
    top: 0;
}
.cover .Access-list:nth-child(2) {
    padding-left: 30px;
    cursor: pointer;
}
.cover .Access-list h1 {
    font-weight: 700;
    font-family: 'ahronbd';
    font-size: 22px;
}
.cover .Access-list h2 {
    font-family: 'ahronbd';
    font-size: 18px;
    padding-bottom: 10px;
}
.cover .Access-list img {
    width: 45px;
    margin-left: 20px;
}
</style>